module.exports = __webpack_public_path__ + "img/element-checkbox.7c9a45d.svg";